import {
  Box,
  SimpleGrid,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useColorModeValue,
} from "@chakra-ui/react";
import CalendarComponent from "components/calendar/CalendarScheduleOne";

// Custom components

// Assets
import LoadingComponent from "components/Main/Loading";
import { formatDateUs } from "helpers/formated";
import useSchedule from "hooks/use-schedule";
import { useEffect } from "react";

export default function ScheduleLeo() {
  const {
    getDataFerragem,
    dataFerragem,
    getDataChaparia,
    dataChaparia,
    dateChaparia,
    dateFerragem,
    loadingChaparia,
    loadingFerragem,
    isFirstData,
  } = useSchedule();
  const bgLoading = useColorModeValue("white", "#111C44");

  useEffect(() => {
    const today = new Date();
    const savedSupplierIds = JSON.parse(localStorage.getItem("activeSupplierIds") || "[]");
    
    if (isFirstData) {
      if (dataFerragem.length === 0) {
        getDataFerragem(
          formatDateUs(new Date(today.getFullYear(), today.getMonth(), 1)),
          formatDateUs(new Date(today.getFullYear(), today.getMonth() + 1, 0)),
          savedSupplierIds
        );
      }
      if (dataChaparia.length === 0) {
        getDataChaparia(
          formatDateUs(new Date(today.getFullYear(), today.getMonth(), 1)),
          formatDateUs(new Date(today.getFullYear(), today.getMonth() + 1, 0)),
          savedSupplierIds
        );
      }
    }
  });

  const getData = (start: any, end: any) => {
    const savedSupplierIds = JSON.parse(localStorage.getItem("activeSupplierIds") || "[]");
    getDataFerragem(start, end, savedSupplierIds);
    getDataChaparia(start, end, savedSupplierIds);
  };
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Tabs variant="soft-rounded" colorScheme="green">
        <TabList pl={8}>
          <Tab
            _selected={{
              bg: "#124907",
              color: "white",
            }}
          >
            Ferragem
          </Tab>
          <Tab
            _selected={{
              bg: "#124907",
              color: "white",
            }}
          >
            Chaparia
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <SimpleGrid
              mb="10px"
              columns={{ sm: 1, md: 1 }}
              spacing={{ base: "20px", xl: "20px" }}
            >
              {loadingFerragem ? (
                <>
                  <Box bg={bgLoading}>
                    <LoadingComponent spinnerSize="50vh" />
                  </Box>
                </>
              ) : (
                <>
                  {dataFerragem && (
                    <>
                      <CalendarComponent
                        data={dataFerragem}
                        sector="FERRAGEM"
                        date={dateFerragem}
                        getData={getData}
                      />
                    </>
                  )}
                </>
              )}
            </SimpleGrid>
          </TabPanel>
          <TabPanel>
            <SimpleGrid
              mb="10px"
              columns={{ sm: 1, md: 1 }}
              spacing={{ base: "20px", xl: "20px" }}
            >
              {loadingChaparia ? (
                <>
                  <Box bg={bgLoading}>
                    <LoadingComponent spinnerSize="50vh" />
                  </Box>
                </>
              ) : (
                <>
                  {dataChaparia && (
                    <>
                      <CalendarComponent
                        data={dataChaparia}
                        sector="CHAPARIA"
                        date={dateChaparia}
                        getData={getData}
                      />
                    </>
                  )}
                </>
              )}
            </SimpleGrid>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}
